/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';

import { isEmpty } from 'lodash';

import DialogContext from './context';

export function useDialog() {
  const context = useContext(DialogContext);

  if (isEmpty(context))
    throw new Error(
      'Empty Context object: useDialog can only be used as a child of a DialogProvider.'
    );

  return context;
}
